const Study = () => {
    return(
        <>
        <div className="studyBlock">
            <div className="infoStudyBlock">
                <p className="infoStudyBlockP">CLINICAL STUDY</p>
                <h2 className="infoStudyBlockH2">We’re investing in a clinical trial to quantify our impact.</h2>
                <p className="infoStudyBlockP2">Lots of programs claim to work but we’re putting our money where our mouth is! We’ve commissioned a clinical trial</p>
                <p className="infoStudyBlockP3">with 290 people to validate how ZOE’s personalized nutrition program compares to standardized nutrition advice. Results will be published in 2023.</p>
            </div>
            <div className="imgStudy">
                <img src="./img/grandfather.png" alt="" />
            </div>
        </div>
        </>
    );
}

export default Study;